
import { defineComponent, watch } from 'vue'
import { defineRule, useField } from 'vee-validate'
import { required, min } from '@vee-validate/rules'
import { useI18n } from 'vue-i18n'

defineRule('required', required)
defineRule('min', min)
export default defineComponent({
  props: {
    modelValue: {
      type: String
    },
    label: {
      type: String,
      default: 'formularios.password.label'
    },
    placeholder: {
      type: String,
      default: 'formularios.password.placeholder'
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const {
      value: field,
      errorMessage,
      meta
    } = useField(
      'password',
      { required: props.required, min: 8 },
      {
        initialValue: props.modelValue,
        label: t(props.label).toString().toLowerCase()
      }
    )

    watch(field, val => emit('update:modelValue', val))
    return {
      t,
      field,
      errorMessage,
      meta
    }
  }
})
